import {
  cmsApiCreateReaction,
  cmsApiDeleteReaction,
} from 'modules/cms/api/reactions/cmsApiReactionEndpoints';
import { CmsApiReactionType } from 'modules/cms/api/reactions/types/CmsApiReactionType';
import { useCmsApiFetchReactions } from 'modules/cms/api/reactions/useCmsApiFetchReactions';

import { CmsReactionButton } from './CmsReactionButton';
import {
  CmsReactionsButtonsContainer,
  CmsReactionsContainer,
  CmsReactionsUserEngagementBar,
  CmsReactionsWrapper,
} from './CmsReactions.styled';
import { CmsReactionsContext } from './CmsReactionsContext';
import { CmsReactionsSummary } from './CmsReactionsSummary';
import { CmsReactionsUserAvatar } from './CmsReactionsUserAvatar';

type Props = { contentId: string };

export function CmsReactions({ contentId }: Props) {
  const { loading, reactionContext, setReactionContext } =
    useCmsApiFetchReactions(contentId);

  const handleReactionClick = (reactionType: CmsApiReactionType) => {
    if (
      !reactionContext.ownReaction ||
      reactionContext.ownReaction.reactionType !== reactionType
    ) {
      cmsApiCreateReaction(contentId, reactionType).then(
        (updatedReactionContext) => {
          if (typeof setReactionContext === 'function') {
            setReactionContext(updatedReactionContext);
          }
        },
      );
    } else {
      cmsApiDeleteReaction(contentId).then((updatedReactionContext) => {
        if (typeof setReactionContext === 'function') {
          setReactionContext(updatedReactionContext);
        }
      });
    }
  };

  return loading ? null : (
    <CmsReactionsContext.Provider value={reactionContext}>
      <CmsReactionsContainer data-qa-id="cms-reactions">
        <CmsReactionsWrapper>
          <CmsReactionsSummary />
          <CmsReactionsUserEngagementBar>
            <CmsReactionsUserAvatar />
            <CmsReactionsButtonsContainer>
              <CmsReactionButton onReactionClick={handleReactionClick} />
            </CmsReactionsButtonsContainer>
          </CmsReactionsUserEngagementBar>
        </CmsReactionsWrapper>
      </CmsReactionsContainer>
    </CmsReactionsContext.Provider>
  );
}
